// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__HjEBZ","colMin":"styles_colMin__3VQZk","colCheckbox":"styles_colCheckbox__3zDsV"};